<template>
    <li>
        <keep-alive>
            <button
                type="button"
                class="tw-btn"
                v-bind:class="{
                    'tw-btn--active': active,
                    'tw-btn--lg': standalone,
                    'tw-btn--xs': !standalone,
                    'tw-btn--info' : !isSoldOut,
                    'tw-btn--danger': isSoldOut
                }"
                v-bind:style="{
                    'margin-top': '10px',
                    'width': standalone ? '70px' : ''
                }"
                :disabled="isSoldOut"
                v-on:click="updateSelectedTimeSlot()">
                {{ timeSlot }}
            </button>
        </keep-alive>
    </li>
</template>

<script lang="ts">
    import { Vue } from "vue-property-decorator";
    import { Component, Prop } from "vue-property-decorator";
    import CartManager from '../../../services/CartManager';
    import TicketWidgetComponent from '../../TicketWidgetComponent';

    @Component({})

    export default class SellableTimeSlots extends TicketWidgetComponent {
        @Prop() public timeSlot!: any;
        @Prop() public isSoldOut!: boolean;
        @Prop() public standalone?: boolean;

        active: boolean = false;

        mounted() {
            // add listener to reset the timeslot
            this.$root.$on('resetTimeSlots', () => {
                this.active = false;
            });
        }

        /**
         * @desc select a timeslot and change its boolean
         * @param {string}
         */
        updateSelectedTimeSlot() {
            this.active = !this.active;

            this.$root.$emit('updateSelectedTimeSlots', this.timeSlot, this.active);
        }
    }
</script>